import React, { FC, useEffect, useState } from 'react'
import { Select } from 'antd'

export interface BaseSelectProps {
  name: string
  options?: Array<any>
  remoteUrl?: string
  defaultValue?: any
  value?: any
  wrapperClassName?: string
  className?: string
  mode?: any
  size?: any
  onChange?: (v: any) => void
}

const BaseSelect: FC<BaseSelectProps> = ({
  name,
  options,
  remoteUrl,
  defaultValue,
  value,
  wrapperClassName,
  className,
  mode,
  size,
  onChange,
}) => {
  const [dataOptions, setDataOptions] = useState([])
  const currentValue = value ?? defaultValue

  useEffect(() => {
    if (!!options && options.length > 0) {
      setDataOptions([...options])
      return
    }

    if (!!remoteUrl) {
      fetch(remoteUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
        .then((res) => res.json())
        .then((res) => {
          setDataOptions(res.data.items)
          return
        })
    }

    return
  }, [options, remoteUrl])

  const handleOnChange = (v: any) => {
    onChange?.(v)
  }

  const handleFilterOption = (input: string, option?: { label?: string }) => {
    return (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
  }

  return (
    <div className={wrapperClassName}>
      <input key={currentValue} type="hidden" name={name} value={currentValue ?? ''} />
      <Select
        showSearch
        className={className}
        style={{ width: '100%' }}
        value={currentValue}
        placeholder='请选择'
        optionFilterProp="label"
        onChange={handleOnChange}
        mode={mode}
        filterOption={handleFilterOption}
        size={size}
        options={dataOptions}
      />
    </div>
  )
}

export default BaseSelect
